/**
 * Breakpoint theme values.
 */
import { Breakpoints } from "@oui/system/breakpoints"

const breakpoint: Breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
}

export default breakpoint
